import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import "./index.css";
// import { store, persistor } from "./redux/store.ts";
import { installRemoteAuthBridge } from "@/shared/lib/remoteAuthBridge";
import { installRemoteLocalisation } from "@/shared/lib/remoteLocalisation";
import { persistor, store } from "@/shared/redux/store/store";
import { WHITE_LABEL_CONFIG, applyWhiteLabelTheme } from "@/whiteLabel";
import AppRouter from "./router/AppRouter";

document.title = WHITE_LABEL_CONFIG.app.title;
applyWhiteLabelTheme();

// The NexForm remote's own calls to the B2B API do not all carry a bearer;
// the bridge completes them from the host's session (see remoteAuthBridge.ts).
installRemoteAuthBridge({
  apiBaseUrl: import.meta.env.VITE_APP_ENDPOINT_URL,
  getAccessToken: () => store.getState().auth?.user?.access_token ?? null,
});
void installRemoteLocalisation();

const faviconLink =
  document.querySelector<HTMLLinkElement>("link[rel*='icon']") ?? document.createElement("link");

faviconLink.rel = "icon";
faviconLink.href = WHITE_LABEL_CONFIG.app.faviconPath;
faviconLink.type = WHITE_LABEL_CONFIG.app.faviconPath.endsWith(".ico")
  ? "image/x-icon"
  : WHITE_LABEL_CONFIG.app.faviconPath.endsWith(".png")
    ? "image/png"
    : "image/jpeg";

if (!faviconLink.parentNode) {
  document.head.appendChild(faviconLink);
}

createRoot(document.getElementById("root")!).render(
  <React.Suspense
    fallback={
      <div className="flex h-screen items-center justify-center text-xl font-semibold text-theme-primary">
        Loading...
      </div>
    }
  >
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Router>
          <AppRouter />
        </Router>
      </PersistGate>
    </Provider>
  </React.Suspense>
);
